<template>
    <div class="card-body">
        <b-container>
            <div class="form">
                <b-row>
                    <b-col>
                        <h4>Activar</h4>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="venta_abonados" v-model="manager.nuevo_abono">
                                <label class="custom-control-label" for="venta_abonados">Activar nuevos abonados</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="renovar_abonados" v-model="manager.renovar_abono">
                                <label class="custom-control-label" for="renovar_abonados">Activar renovación de abonados</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="futbol_base" v-model="manager.futbol_base">
                                <label class="custom-control-label" for="futbol_base">Activar cantera</label>
                            </div>

                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="venta_simpatizantes" v-model="manager.venta_simpatizantes">
                                <label class="custom-control-label" for="venta_simpatizantes">Activar venta de {{ configuracion.simpatizantes }}</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_experiencias" v-model="manager.activar_experiencias">
                                <label class="custom-control-label" for="activar_experiencias">Activar experiencias</label>
                            </div>
                        </div>
        
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_pack" v-model="manager.activar_pack">
                                <label class="custom-control-label" for="activar_pack">Activar pack</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="partidos" v-model="manager.partidos">
                                <label class="custom-control-label" for="partidos">Activar eventos</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="renovacion_futbol_base" v-model="manager.renovacion_futbol_base">
                                <label class="custom-control-label" for="renovacion_futbol_base">Activar renovación en cantera</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_acreditaciones" v-model="manager.activar_acreditaciones">
                                <label class="custom-control-label" for="activar_acreditaciones">Activar acreditaciones</label>
                            </div>
                        </div>
                    </b-col>
                    <b-col>
                        <h4>Ocultar</h4>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_abonos" v-model="manager.ocultar_abonos">
                                <label class="custom-control-label" for="ocultar_abonos">Ocultar nuevos abonos</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_eventos" v-model="manager.ocultar_eventos">
                                <label class="custom-control-label" for="ocultar_eventos">Ocultar eventos</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_renovar_abono" v-model="manager.ocultar_renovar_abono">
                                <label class="custom-control-label" for="ocultar_renovar_abono">Ocultar renovación abonos</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_futbol_base" v-model="manager.ocultar_futbol_base">
                                <label class="custom-control-label" for="ocultar_futbol_base">Ocultar cantera</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_simpatizantes" v-model="manager.ocultar_simpatizantes">
                                <label class="custom-control-label" for="ocultar_simpatizantes">Ocultar simpatizantes</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_experiencias" v-model="manager.ocultar_experiencias">
                                <label class="custom-control-label" for="ocultar_experiencias">Ocultar experiencias</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_pack" v-model="manager.ocultar_pack">
                                <label class="custom-control-label" for="ocultar_pack">Ocultar pack</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_renovacion_futbol_base" v-model="manager.ocultar_renovacion_futbol_base">
                                <label class="custom-control-label" for="ocultar_renovacion_futbol_base">Ocultar renovación en cantera</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_acreditaciones" v-model="manager.ocultar_acreditaciones">
                                <label class="custom-control-label" for="ocultar_acreditaciones">Ocultar acreditaciones</label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </b-container>
    </div>
</template>

<script>


export default {
    props: ['manager'],
    data() {
        return {
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
    },
    methods: {
        guardarOpciones() {
            this.$emit('guardar');
        }
    },
}
</script>
